import React from "react";
import { HiLocationMarker } from "react-icons/hi";
import { FaCity, FaMapMarkerAlt } from "react-icons/fa";
import { BiSolidBuildingHouse } from "react-icons/bi";
import { TbWorldLatitude } from "react-icons/tb";

interface DisplaybussinessAddressProps {
  address: string;
  cityName: string;
  state: string;
  zipCode: string;
  latitude: number;
  longitude: number;
}

const DisplaybussinessAddress: React.FC<DisplaybussinessAddressProps> = ({
  address,
  cityName,
  state,
  zipCode,
  latitude,
  longitude,
}) => {
  return (
    <div className="mb-8">
      <div className="flex justify-between items-center mb-4">
        <h2 className="xxxl:text-2xl xxl:text-xl text-lg font-semibold text-black">
          Business address information
        </h2>
        <span className="text-sm font-medium text-customGrayBase">
          Step 2/3
        </span>
      </div>

      <div className="bg-white shadow-sm border border-gray-100 p-6 rounded-xl">
        <div className="space-y-4">
          <div className="flex">
            <div className="flex items-center text-gray-500 min-w-32 w-32 shrink-0">
              <HiLocationMarker className="mr-2 text-lg" />
              <span className="text-sm font-medium">Address:</span>
            </div>
            <span className="text-sm text-gray-700">
              {address || "Not Provided"}
            </span>
          </div>
          <div className="flex">
            <div className="flex items-center text-gray-500 min-w-32 w-32 shrink-0">
              <FaCity className="mr-2 text-lg" />
              <span className="text-sm font-medium">City:</span>
            </div>
            <span className="text-sm text-gray-700">
              {cityName || "Not Provided"}
            </span>
          </div>
          <div className="flex">
            <div className="flex items-center text-gray-500 min-w-32 w-32 shrink-0">
              <FaMapMarkerAlt className="mr-2 text-lg" />
              <span className="text-sm font-medium">State:</span>
            </div>
            <span className="text-sm text-gray-700">
              {state || "Not Provided"}
            </span>
          </div>
          <div className="flex">
            <div className="flex items-center text-gray-500 min-w-32 w-32 shrink-0">
              <FaMapMarkerAlt className="mr-2 text-lg" />
              <span className="text-sm font-medium">Zip Code:</span>
            </div>
            <span className="text-sm text-gray-700">
              {zipCode || "Not Provided"}
            </span>
          </div>
          <div className="flex">
            <div className="flex items-center text-gray-500 min-w-32 w-32 shrink-0">
              <TbWorldLatitude className="mr-2 text-lg" />
              <span className="text-sm font-medium">Latitude:</span>
            </div>
            <span className="text-sm text-gray-700">
              {latitude || "Not Provided"}
            </span>
          </div>
          <div className="flex">
            <div className="flex items-center text-gray-500 min-w-32 w-32 shrink-0">
              <TbWorldLatitude className="mr-2 text-lg" />
              <span className="text-sm font-medium">Longitude:</span>
            </div>
            <span className="text-sm text-gray-700">
              {longitude || "Not Provided"}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DisplaybussinessAddress;
